import debug from 'debug';

import { isHostLocal } from 'utilities';

const log = debug('api:auth');

function authUri() {
  return (
    isHostLocal(window.location.hostname) ?
      'https://adgen-dev.spotify.com/auth/' :
      '/auth/'
  );
}

export function LoggedOutError() {
  Error.call(this);
}
LoggedOutError.prototype = Object.create(Error.prototype);

export function AuthSystemError(message) {
  Error.call(this);
  this.message = message;
}
AuthSystemError.prototype = Object.create(Error.prototype);

export function retrieveToken() {
  log('retrieving token from: %s', authUri());

  return fetch(authUri(), { credentials: 'include' })
    .then(res => {
      switch (res.status) {
        case 200:
          return res.json();
        case 400: // sso cookie is invalid/expired
        case 401:
          return Promise.reject(new LoggedOutError());
        default:
          return Promise.reject(new AuthSystemError(res.statusText));
      }
    })
    .then(auth => auth.accessToken);
}

/*
 * Detect what country user is visiting from
 * x-geo-country header is provided by weblb
 * @returns {String} Country code
 */
export function getIpCountry() {
  const url = `${document.location.origin}/ip`;
  return fetch(url).then(r => r.headers.get('x-geo-country'));
}



// WEBPACK FOOTER //
// ./src/api/auth.js